export default class PluginError extends Error {
    constructor(plugin, message) {
        super(message);
        this.plugin = plugin;
    }
}